export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/as-plus.98785018.svg","height":12,"width":126};